import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddGuideFeedbackMutationVariables = Types.Exact<{
  input: Types.Guide_Feedbacks_Insert_Input;
}>;


export type AddGuideFeedbackMutation = { __typename?: 'mutation_root', insert_guide_feedbacks_one?: { __typename?: 'guide_feedbacks', id: any, helpful: boolean, notes?: string | null, created_by_user_id: string, created_at: any, guide_id: any } | null };


export const AddGuideFeedbackDocument = gql`
    mutation addGuideFeedback($input: guide_feedbacks_insert_input!) {
  insert_guide_feedbacks_one(object: $input) {
    id
    helpful
    notes
    created_by_user_id
    created_at
    guide_id
  }
}
    `;
export type AddGuideFeedbackMutationFn = Apollo.MutationFunction<AddGuideFeedbackMutation, AddGuideFeedbackMutationVariables>;

/**
 * __useAddGuideFeedbackMutation__
 *
 * To run a mutation, you first call `useAddGuideFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuideFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuideFeedbackMutation, { data, loading, error }] = useAddGuideFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGuideFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddGuideFeedbackMutation, AddGuideFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGuideFeedbackMutation, AddGuideFeedbackMutationVariables>(AddGuideFeedbackDocument, options);
      }
export type AddGuideFeedbackMutationHookResult = ReturnType<typeof useAddGuideFeedbackMutation>;
export type AddGuideFeedbackMutationResult = Apollo.MutationResult<AddGuideFeedbackMutation>;
export type AddGuideFeedbackMutationOptions = Apollo.BaseMutationOptions<AddGuideFeedbackMutation, AddGuideFeedbackMutationVariables>;